import { render, staticRenderFns } from "./ApolloPosts.vue?vue&type=template&id=221249d6&"
import script from "./ApolloPosts.vue?vue&type=script&lang=js&"
export * from "./ApolloPosts.vue?vue&type=script&lang=js&"
import style0 from "./ApolloPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports